import type { ValueOf } from './base/alias.type';

export const icons = {
  ADD: 'add',
  ALERT_FILL: 'alert-fill',
  ALERT_LINE: 'alert-line',
  ANALYZE: 'analyze',
  APP_GENERIC: 'app-generic',
  APP_LICENSE: 'app-license',
  APPS_ADD: 'apps-add',
  APPS_LICENSES: 'apps-licenses',
  APPS_OPEN_WITH: 'apps-open-with',
  ARROW_DOWN: 'arrow-down',
  ARROW_LEFT: 'arrow-left',
  ARROW_RIGHT_LEFT: 'arrow-right-left',
  ARROW_RIGHT: 'arrow-right',
  ARROW_UP: 'arrow-up',
  BARS_PROGRESS: 'bars-progress',
  BLUEPRINT: 'blueprint',
  BURGER_MENU: 'burger-menu',
  CALENDAR_CLOCK: 'calendar-clock',
  CAMERA: 'camera',
  CANCEL_LINE: 'cancel-line',
  CHECK_ALL: 'check-all',
  CHECK: 'check',
  CHEVRON_DOWN: 'chevron-down',
  CHEVRON_LEFT: 'chevron-left',
  CHEVRON_RIGHT: 'chevron-right',
  CHEVRON_UP: 'chevron-up',
  CLOSE: 'close',
  CLOUD_CONNECTED: 'cloud-connected',
  CLOUD_DISCONNECTED: 'cloud-disconnected',
  CLOUD_DOWNLOAD: 'cloud-download',
  CLOUD_UPLOAD: 'cloud-upload',
  COLLAPSE: 'collapse',
  CONFIRM_FILL: 'confirm-fill',
  CONFIRM_LINE: 'confirm-line',
  CONTEXT_MENU: 'context-menu',
  COPY: 'copy',
  DATA_ANALYSIS: 'data-analysis',
  DATE_CREATED: 'date-created',
  DATE_MODIFIED: 'date-modified',
  DATE: 'date',
  DEVICE_CONNECTION: 'device-connection',
  DEVICE_GENERIC: 'device-generic',
  DEVICE_SEND_TO: 'device-send-to',
  DEVICE_SETTINGS: 'device-settings',
  DISPLAY_GRID: 'display-grid',
  DISPLAY_LIST: 'display-list',
  DOC_VERSION: 'doc-version',
  DOWNLOAD: 'download',
  EDIT: 'edit',
  EMAIL: 'email',
  EXPAND: 'expand',
  EXTERNAL_CONTEXT: 'external-context',
  FILE_EXPORT: 'file-export',
  FILE_INVOICE_DOLLAR: 'file-invoice-dollar',
  FILTER: 'filter',
  FOLDER_FILL: 'folder-fill',
  FOLDER_GROUP: 'folder-group',
  FOLDER_MOVE_TO: 'folder-move-to',
  FOLDER: 'folder',
  GLOBAL_MENU: 'global-menu',
  GLOBE: 'globe',
  GRAPH_PIE: 'graph-pie',
  HELP: 'help',
  HIERARCHY_DOWN: 'hierarchy-down',
  HISTORY: 'history',
  HOME: 'home',
  IMAGE_GALLERY: 'image-gallery',
  IMAGE: 'image',
  INFO_FILL: 'info-fill',
  INFO_LINE: 'info-line',
  INSPECT: 'inspect',
  LEAF_NODE: 'leaf-node',
  LINK_SIMPLE: 'link-simple',
  LINK_SLASH: 'link-slash',
  LINK: 'link',
  LIST_MANAGE: 'list-manage',
  LIVE: 'live',
  LOCATION: 'location',
  LOCK_FILL: 'lock-fill',
  LOG_OUT: 'log-out',
  NOTIFICATIONS: 'notifications',
  NUMBER_KEY: 'number-key',
  ORGANIZATION: 'organization',
  OVERFLOW: 'overflow',
  PAUSE: 'pause',
  PENDING: 'pending',
  PLAN_ADD: 'plan-add',
  PLAN: 'plan',
  PLAY_FILL: 'play-fill',
  PLAY: 'play',
  PROFIL_FILL: 'profil-fill',
  PROFILE: 'profile',
  QUOTE_AGAIN: 'quote-again',
  REFRESH: 'refresh',
  REMOVE: 'remove',
  RENAME: 'rename',
  REPORT_SEND_TO: 'report-send-to',
  REPORT: 'report',
  SEARCH: 'search',
  SECURITY_LOCK: 'security-lock',
  SECURITY_SHIELD: 'security-shield',
  SEND: 'send',
  SETTING: 'setting',
  SETTINGS_ALT: 'settings-alt',
  SHARE: 'share',
  SIDEBAR_COLLAPSE: 'sidebar-collapse',
  SIDEBAR_EXPAND: 'sidebar-expand',
  SORT_A_Z: 'sort-a-z',
  SORT_ASCENDING: 'sort-ascending',
  SORT_DESCENDING: 'sort-descending',
  SORT_Z_A: 'sort-z-a',
  SUPPORT: 'support',
  TRASH_DELETE: 'trash-delete',
  TRASH_RESTORE: 'trash-restore',
  TRASH_SEND: 'trash-send',
  TRASH: 'trash',
  UNDO: 'undo',
  UPDATE_SYNC: 'update-sync',
  UPLOAD: 'upload',
  USER_ADD: 'user-add',
  USER_ADMIN: 'user-admin',
  USER_BUYER: 'user-buyer',
  USER_DELETE: 'user-delete',
  USER_GUEST: 'user-guest',
  USER_OWNER: 'user-owner',
  USER_REMOVE: 'user-remove',
  USER_ROLE: 'user-role',
  USER: 'user',
  USERS: 'users',
  VERIFIED: 'verified',
  VISIBILITY_HIDE: 'visibility-hide',
  VISIBILITY_SHOW: 'visibility-show',
} as const;
export type Icon = ValueOf<typeof icons>;
export const iconList: Icon[] = Object.values(icons) as Icon[];

export const applicationsIcons = {
  AEROVIEW: 'aeroview',
  DRIVE: 'drive',
  EQUIPMENT_MANAGER: 'equipment-manager',
  GENERIC_APP: 'generic-app',
  IPM: 'ipm',
  ORGANIZATION: 'organization',
  RCS: 'rcs',
  VANTA_DATA: 'vanta-data',
  VISOL: 'visol',
  WINDVIEW: 'windview',
} as const;
export type ApplicationIcon = ValueOf<typeof applicationsIcons>;

export const filesIcons = {
  ARCHIVE: 'archive',
  DATA: 'data',
  FILE: 'file',
  FOLDER: 'folder',
  IMAGE: 'image',
  NDE: 'nde',
  OMNISCAN_NDT: 'omniscan-ndt',
  PDF: 'pdf',
  PRESENTATION: 'presentation',
  PROBE_NDT: 'probe-ndt',
  SETUP: 'setup',
  SPREADSHEET: 'spreadsheet',
  TEXT: 'text',
  VIDEO: 'video',
} as const;
export type FileIcon = ValueOf<typeof filesIcons>;
